import { Outlet } from 'react-router-dom';

import { Page, PageHeader } from '@/components';
import { withLoader } from '@/hocs';
import ToolsManagementGrid from '@/pages/Tools/ToolsManagementGrid';

const ToolsManagement = () => {
  return (
    <Page title="Tools">
      <PageHeader title="Tools" />
      <ToolsManagementGrid />
      <Outlet />
    </Page>
  );
};
export default withLoader(ToolsManagement);
